import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/landing";
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [minutes, setMinutes] = useState(2);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let i = Math.floor(Math.random() * buyers.length);
    const show = () => {
      i = (i + 1 + Math.floor(Math.random() * 3)) % buyers.length;
      setIndex(i);
      setMinutes(1 + Math.floor(Math.random() * 12));
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_MS);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, SHOW_MS + GAP_MS);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <AnimatePresence data-id="element-44" data-mp="114tka6wy1mb8">
      {visible && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 12,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-[340px]" data-id="element-45" data-mp="1fur1g2wghbqx">
          <div className="relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_-8px_rgba(11,27,46,0.35)] ring-1 ring-navy/10" data-id="element-46" data-mp="x5b05dcy5f9g">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy text-sm font-extrabold text-sky" data-id="element-47" data-mp="s4n0k3anjq3m">
              {buyer.name.replace(/^Dra?\.\s/, "").charAt(0)}
            </span>
            <div className="min-w-0 text-left" data-id="element-48" data-mp="23nh9w255hcwg">
              <p className="truncate text-sm font-bold text-navy" data-id="element-49" data-mp="2apcpataouper">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-ink/70" data-id="element-50" data-mp="2flte7pppp7sw">just purchased Liposuction Case Lab™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-51" data-mp="2kniov490vjgg">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="2pl2fz4qtjqpt" /> Verified · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:text-ink" data-id="element-53" data-mp="1wwwtacg7frnc">
              <XIcon className="h-4 w-4" data-id="element-54" data-mp="26osrrom7djs3" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}